import HttpService from '../base.service/HttpService'

export default class RefService extends HttpService {
  getCompanyList () {
    const api = process.env.VUE_APP_API + '/ref/company-list'
    return this.get({}, api)
  }

  getBranchList (param) {
    const api = process.env.VUE_APP_API + '/ref/branch-loop'
    return this.get(param, api)
  }

  getSpkluList (param) {
    const api = process.env.VUE_APP_API + '/ref/spklu'
    return this.get(param, api)
  }
}
